export const STORE_KEYS = {
    accessTokenKey: 'accessToken',
    clientKey: 'client',
    correlationIdKey: 'correlationId',
    envKey: 'account-services-mfe__selected-env',
    givenNameKey: 'givenName',
    idTokenKey: 'idToken',
    languageKey: 'language',
    mockData: 'mockData',
    selectedIdKey: 'selectedAccountId'
};
export default STORE_KEYS;
